export interface ArticleMeta {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  image: string;
  category: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: 'basetao-spreadsheet-guide',
    title: 'Complete Basetao Spreadsheet Guide 2026: Master Your Shopping Workflow',
    excerpt: 'Learn everything about Basetao Spreadsheet systems — from product research and price tracking to shipping optimization and warehouse management. A step-by-step guide for beginners and experienced shoppers.',
    date: '2026-08-01',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20laptop%20showing%20spreadsheet%20screen%2C%20warm%20beige%20wooden%20desk%2C%20coffee%20cup%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20clean%20modern%20aesthetic%2C%20cozy%20productive%20atmosphere&width=800&height=450&seq=article-guide-101&orientation=landscape',
    category: 'Guide',
  },
  {
    slug: 'basetao-review',
    title: 'Basetao Review 2026: Is Basetao Legit? Honest Buyer Guide',
    excerpt: 'An in-depth Basetao review covering user experience, shipping costs, warehouse service quality, and whether Basetao is a legitimate shopping platform for international buyers.',
    date: '2026-08-03',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Person%20opening%20a%20carefully%20packaged%20international%20delivery%20box%20on%20warm%20beige%20wooden%20table%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20satisfaction%20and%20anticipation%20mood%2C%20clean%20modern%20aesthetic&width=800&height=450&seq=article-review-102&orientation=landscape',
    category: 'Review',
  },
  {
    slug: 'basetao-shipping-cost',
    title: 'Basetao Shipping Cost Guide 2026: Real Prices, Tips & Savings',
    excerpt: 'Complete breakdown of Basetao shipping costs across different lines. Learn how to calculate, compare, and reduce your shipping expenses with proven strategies.',
    date: '2026-08-05',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20cardboard%20shipping%20boxes%20with%20international%20shipping%20labels%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20logistics%20photography%2C%20organized%20warehouse%20aesthetic%2C%20high%20detail&width=800&height=450&seq=article-shipping-103&orientation=landscape',
    category: 'Shipping',
  },
  {
    slug: 'basetao-coupon',
    title: 'Basetao Coupon & Discount Code 2026: How To Save Money',
    excerpt: 'Discover the latest working Basetao coupons, discount codes, and money-saving strategies. Updated regularly with verified promotional offers.',
    date: '2026-08-06',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20sale%20and%20discount%20tags%20arranged%20artistically%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20marketing%20photography%2C%20vibrant%20promotional%20aesthetic%2C%20high%20detail&width=800&height=450&seq=article-coupon-104&orientation=landscape',
    category: 'Savings',
  },
  {
    slug: 'basetao-warehouse',
    title: 'Basetao Warehouse Explained: How Warehouse Storage Works',
    excerpt: 'Understand the complete Basetao warehouse process from item arrival to consolidation. Learn about storage periods, QC photos, and shipping preparation.',
    date: '2026-08-07',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=Modern%20organized%20warehouse%20shelves%20with%20neatly%20arranged%20packages%20and%20boxes%2C%20warm%20ambient%20lighting%2C%20editorial%20logistics%20photography%2C%20clean%20industrial%20aesthetic%2C%20high%20detail%2C%20professional%20atmosphere&width=800&height=450&seq=article-warehouse-105&orientation=landscape',
    category: 'Warehouse',
  },
  {
    slug: 'basetao-vs-superbuy',
    title: 'Basetao vs Superbuy: Complete Agent Comparison 2026',
    excerpt: 'Side-by-side comparison of Basetao and Superbuy covering shipping rates, service fees, warehouse features, QC quality, and user experience.',
    date: '2026-08-08',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=Two%20neatly%20arranged%20premium%20shopping%20bags%20side%20by%20side%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20comparison%20photography%2C%20balanced%20composition%2C%20high%20detail%2C%20neutral%20aesthetic&width=800&height=450&seq=article-vs-106&orientation=landscape',
    category: 'Comparison',
  },
  {
    slug: 'basetao-vs-sugargoo',
    title: 'Basetao vs Sugargoo: Which Agent Is Better in 2026?',
    excerpt: 'Detailed analysis comparing Basetao and Sugargoo on pricing, shipping options, website usability, customer support, and overall value for money.',
    date: '2026-08-09',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=Premium%20packaging%20boxes%20with%20different%20shipping%20labels%20arranged%20side%20by%20side%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20comparison%20photography%2C%20balanced%20composition%2C%20high%20detail&width=800&height=450&seq=article-vs2-107&orientation=landscape',
    category: 'Comparison',
  },
  {
    slug: 'reduce-basetao-shipping',
    title: 'How To Reduce Basetao Shipping Cost: 15 Proven Strategies',
    excerpt: 'Expert tips and tricks to minimize your Basetao international shipping expenses. From consolidation methods to shipping line selection and packaging optimization.',
    date: '2026-08-09',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Calculator%20and%20shipping%20documents%20on%20clean%20minimal%20warm%20beige%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20business%20photography%2C%20planning%20and%20optimization%20aesthetic%2C%20organized%20workspace%2C%20high%20detail&width=800&height=450&seq=article-reduce-108&orientation=landscape',
    category: 'Shipping',
  },
  {
    slug: 'basetao-qc-guide',
    title: 'Basetao QC Photo Guide: How To Check Quality Before Shipping',
    excerpt: 'Complete guide to understanding and using Basetao quality control photos. Learn what to look for, common defects to spot, and how to request re-shots.',
    date: '2026-08-10',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=Premium%20fashion%20item%20being%20inspected%20with%20magnifying%20glass%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20quality%20control%20photography%2C%20attention%20to%20detail%20aesthetic%2C%20high%20detail&width=800&height=450&seq=article-qc-109&orientation=landscape',
    category: 'Guide',
  },
  {
    slug: 'basetao-template',
    title: 'Best Basetao Spreadsheet Templates: Free Download & Setup',
    excerpt: 'Collection of the best free Basetao Spreadsheet templates with pre-built formulas, formatting, and automated calculations. Ready-to-use formats for every shopper.',
    date: '2026-08-10',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20laptop%20screen%20displaying%20organized%20spreadsheet%20grid%20with%20data%20rows%2C%20warm%20beige%20desk%20background%2C%20soft%20natural%20lighting%2C%20editorial%20productivity%20photography%2C%20minimal%20workspace%20aesthetic%2C%20high%20detail&width=800&height=450&seq=article-template-110&orientation=landscape',
    category: 'Guide',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export interface FeatureItem {
  iconClass: string;
  title: string;
  description: string;
}

export const featureItems: FeatureItem[] = [
  {
    iconClass: 'ri-search-eye-line',
    title: 'Product Research',
    description: 'Organize and compare products across multiple sellers with structured spreadsheet templates that save hours of manual browsing.',
  },
  {
    iconClass: 'ri-ship-2-line',
    title: 'Shipping Optimization',
    description: 'Calculate and compare shipping costs across different lines to find the most cost-effective option for your order size and destination.',
  },
  {
    iconClass: 'ri-archive-line',
    title: 'Warehouse Tracking',
    description: 'Monitor your items as they arrive at the warehouse with detailed tracking columns and automated status updates.',
  },
  {
    iconClass: 'ri-camera-line',
    title: 'QC Management',
    description: 'Track quality control photos, note any issues, and make informed decisions before approving items for international shipping.',
  },
  {
    iconClass: 'ri-file-list-3-line',
    title: 'Order Planning',
    description: 'Plan your hauls strategically with budget tracking, weight estimates, and priority ranking to maximize value per shipment.',
  },
  {
    iconClass: 'ri-bar-chart-box-line',
    title: 'Cost Comparison',
    description: 'Compare total costs including item price, domestic shipping, service fees, and international shipping in one unified view.',
  },
];

export interface WorkflowStep {
  step: number;
  title: string;
  description: string;
  iconClass: string;
}

export const workflowSteps: WorkflowStep[] = [
  {
    step: 1,
    title: 'Find Products',
    description: 'Browse categories and seller listings to discover items that match your style and budget. Use the product links on this site to start exploring.',
    iconClass: 'ri-shopping-bag-3-line',
  },
  {
    step: 2,
    title: 'Save to Spreadsheet',
    description: 'Copy product links, prices, and seller information into your Basetao Spreadsheet template for organized tracking and comparison.',
    iconClass: 'ri-file-copy-2-line',
  },
  {
    step: 3,
    title: 'Compare Prices',
    description: 'Use spreadsheet formulas and sorting to compare prices across sellers, factoring in all costs for a true total comparison.',
    iconClass: 'ri-scales-3-line',
  },
  {
    step: 4,
    title: 'Check QC Photos',
    description: 'Review warehouse quality control photos stored in your spreadsheet to verify items match descriptions before shipping.',
    iconClass: 'ri-gallery-line',
  },
  {
    step: 5,
    title: 'Optimize Shipping',
    description: 'Calculate weight and volume to choose the best shipping line. Compare carrier rates and estimated delivery times.',
    iconClass: 'ri-rocket-2-line',
  },
  {
    step: 6,
    title: 'Complete Purchase',
    description: 'Finalize your order with confidence, knowing every item has been tracked, compared, and optimized through your spreadsheet system.',
    iconClass: 'ri-check-double-line',
  },
];

export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: 'What Is a Basetao Spreadsheet?',
    answer: 'A Basetao Spreadsheet is a structured organizational system that helps shoppers track products, compare prices across sellers, manage warehouse information, monitor quality control photos, calculate shipping costs, and optimize their entire shopping workflow. It typically includes columns for product links, prices, sizes, seller ratings, warehouse status, QC photo links, weight estimates, and shipping calculations.',
  },
  {
    question: 'Is Basetao Legit and Safe to Use?',
    answer: 'Yes, Basetao is a legitimate shopping agent platform that has been operating for years, serving thousands of international buyers. They provide warehouse storage, quality control photography, consolidation services, and multiple shipping options. Always verify you are on the official website and follow standard online shopping safety practices.',
  },
  {
    question: 'How Much Does Basetao Shipping Cost?',
    answer: 'Basetao shipping costs vary based on package weight, dimensions, destination country, and shipping line chosen. Economy lines can start from approximately $15-20/kg, while express options range from $25-40/kg. Using a Basetao Spreadsheet helps you calculate exact costs before committing to a shipping method. Actual rates depend on current carrier pricing.',
  },
  {
    question: 'Can I Use Basetao Discount Codes or Coupons?',
    answer: 'Basetao occasionally offers promotional discount codes and coupons for shipping fees and service charges. These can include new user discounts, seasonal promotions, and loyalty rewards. Check the latest Basetao coupon guide on our site for current active codes. Using spreadsheets to track promotional periods helps maximize savings.',
  },
  {
    question: 'How Does the Basetao Warehouse System Work?',
    answer: 'The Basetao warehouse receives items you purchase, provides quality control photography, stores items for free during a grace period (typically 30-90 days), and consolidates multiple orders into single shipments. Your spreadsheet helps track which items have arrived, QC status, storage deadlines, and consolidation planning.',
  },
  {
    question: 'Where Can I Find Basetao Spreadsheet Templates?',
    answer: 'Basetao Spreadsheet templates are available through community resources, shopping forums, and guide websites. A good template includes columns for product name, URL, price, seller, size/color, warehouse status, QC photo links, weight, shipping estimate, and total cost calculations. Our complete guide provides template structure recommendations.',
  },
];